// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3z-sK","errors":"Errors_errors__1NO81"};